import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const CloseThick: FC<IIconsProps> = ({
  color,
  size = IconScale.M,
}: IIconsProps) => {
  const theme = useTheme();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 10 10"
      fill="none"
    >
      <rect
        x="1"
        y="2.41418"
        width="2"
        height="9.05097"
        transform="rotate(-45 1 2.41418)"
        fill={color ?? theme.palette.primary.main}
      />
      <rect
        x="7.39999"
        y="1.01416"
        width="2"
        height="9.05097"
        transform="rotate(45 7.39999 1.01416)"
        fill={color ?? theme.palette.primary.main}
      />
    </svg>
  );
};

export default CloseThick;
